var rtl_rtlignore_default = {
  "rtl": "GAnby",
  "ltr": "SI1sR"
};
export {
  rtl_rtlignore_default as default
};
//# sourceMappingURL=rtl.rtlignore-scss.js.map
